import { render, staticRenderFns } from "./RemoveTeamMemberDialog.vue?vue&type=template&id=89a32a8e&"
import script from "./RemoveTeamMemberDialog.vue?vue&type=script&lang=js&"
export * from "./RemoveTeamMemberDialog.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports